export function validateImageSize(file) {
  if (file.size <= 10 * 1024 * 1024) {
    return true; // Image size is valid (less than or equal to 10 MB)
  } else {
    return false; // Image size is not valid (larger than 10 MB)
  }
}
